import BetProfitAndLoss from "./Profile&Loss";

export default BetProfitAndLoss;